import Signaler from 'signalerjs';
import featuresFlags from '../constants/feature-flags';

interface IFeatureFlags {
  [key: string]: string;
}
interface Signaler {
  setFeatureFlag(flag: string, group: string): void;
}

export const signaler = new Signaler(featuresFlags);

export function setFeatureFlagsFromUrl(signaler: Signaler): void {
  const query: URLSearchParams = new URLSearchParams(window.location.search);
  const selectInto: string | null = query.get('selectInto');

  if (!selectInto) {
    return;
  }

  const selectedTests: IFeatureFlags = {};
  selectInto.split(',').forEach((feature: string) => {
    const [flag, group] = feature.split(':');
    selectedTests[flag] = group;
  });

  Object.keys(selectedTests).forEach(key => {
    if (Object.keys(featuresFlags).includes(key)) {
      signaler.setFeatureFlag(key, selectedTests[key]);
    }
  });
}
